var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78007 3.60156H5.07419C4.51256 3.60156 3.97392 3.82281 3.57679 4.21664C3.17965 4.61046 2.95654 5.14461 2.95654 5.70156V18.3016C2.95654 18.8585 3.17965 19.3927 3.57679 19.7865C3.97392 20.1803 4.51256 20.4016 5.07419 20.4016H8.78007M9.04326 12.0016H21.0433M21.0433 12.0016L16.4581 7.20156M21.0433 12.0016L16.4581 16.8016",
    stroke: "#797E85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutIcon);
export default __webpack_public_path__ + "static/media/logOutIcon.57b8a18fc23e478abed70b761e5163e5.svg";
export { ForwardRef as ReactComponent };